function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M25.007 24.605l-4.028-1.538V7.787l4.028 1.57v15.248zm-6.028-1.611l-5.951 1.646V9.327l5.951-1.68v15.347zM26.37 7.742l-6.028-2.348c-.034-.013-.068-.008-.102-.018a1.078 1.078 0 00-.17-.03.943.943 0 00-.26.013c-.034.006-.069-.005-.102.004l-7.612 2.149L6.392 5.08A1.001 1.001 0 005 6v11.103a1 1 0 002 0v-9.59l4.028 1.716v15.219L7 22.758v-1.662a1 1 0 00-2 0v1.662a1.99 1.99 0 001.235 1.848l5.402 2.268.003.002h.001c.01.003.02.002.03.006.113.043.232.072.357.072.088 0 .177-.012.267-.036l7.634-2.111 5.721 2.184a1.002 1.002 0 001.357-.934V8.673a.999.999 0 00-.637-.931z",
  fill: "#000",
  fillRule: "evenodd"
});

function SvgIcBasicMapInitialization(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32
  }, props), _ref);
}

export default SvgIcBasicMapInitialization;